import { AlternativesInfo } from "@pages/alternatives/interakt";
import { isJSXElement } from "@utils/common";
import Image from "next/image";
import React from "react";

interface AlternativeInformationProps {
    data: AlternativesInfo[];
}

export const AlternativeInformation: React.FC<AlternativeInformationProps> = ({ data }) => {
    return (
        <>
            {data.map(({ id, title, description, image, imgAlt, videoUrl, list, features }) => (
                <div key={id}>
                    <h3 className="text-black text-4xl font-semibold pb-8">{title}</h3>
                    {description && <div className="text-lg pb-6">{description}</div>}
                    {image && imgAlt == "whatsapp-growth-tool" ? (
                        <Image height={450} width={800} src={image} alt={imgAlt} className="h-auto w-full" />
                    ) : (
                        image && (
                            <>
                                <div className="w-full md:block hidden">
                                    <Image height={800} width={600} src={image} alt={imgAlt ?? ""} className="w-full h-auto" />
                                </div>

                                <Image height={450} width={800} src={image} alt={imgAlt ?? ""} className="h-auto block md:hidden" />
                            </>
                        )
                    )}

                    {videoUrl && (
                        <>
                            <div className="w-full h-96 my-6  md:block hidden">
                                <iframe
                                    className="w-full h-full"
                                    src={videoUrl}
                                    title={"Gallabox"}
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                    allowFullScreen
                                />
                            </div>

                            <div className="w-full h-50 my-6  block md:hidden">
                                <iframe
                                    className="w-full h-full"
                                    src={videoUrl}
                                    title={"Gallabox"}
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                    allowFullScreen
                                />
                            </div>
                        </>
                    )}

                    {list &&
                        list?.map((item, index) => (
                            <p key={index} className="pt-6 text-lg">
                                {item.item}
                            </p>
                        ))}

                    <div className="pt-8">
                        <p className="text-2xl font-medium">{features?.title}</p>
                        <ul>
                            {features?.featuresList.map(({ item }, index) =>
                                isJSXElement(item) ? (
                                    <React.Fragment key={index}>{item}</React.Fragment>
                                ) : (
                                    <li key={index} className="text-lg">
                                        {item}
                                    </li>
                                )
                            )}
                        </ul>
                    </div>
                </div>
            ))}
        </>
    );
};
